exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._38Xh1iSaWLQmoP img{height:115px;width:279px;border-radius:3px}._38Xh1iSaWLQmoP p{text-align:center;font-size:14px;line-height:20px;color:#5e6c84;padding-bottom:8px}.cHkZv48-0LnsYG{padding-top:15px;font-size:16px;line-height:20px;text-align:center;color:#000}._3feul24NrD66l8{margin-bottom:0;border-radius:3px}", ""]);

// exports
exports.locals = {
	"createTeamPrompt": "_38Xh1iSaWLQmoP",
	"createTeamTitle": "cHkZv48-0LnsYG",
	"createTeamPromptContinueButton": "_3feul24NrD66l8"
};